import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import {
  Letterhead,
  LetterheadLight
} from "src/app/backend/models/letterhead/letterhead";
import { LetterheadCreate } from "src/app/backend/models/letterhead/letterhead-create";
import { PageRequest } from "src/app/support/page-request";
import { PaginatedResult } from "src/app/support/paginated-result";
import { LetterheadUpdate } from "src/app/backend/models/letterhead/letterhead-update";

export const LETTERHEAD_FREE = "-1";

@Injectable()
export abstract class LetterheadBackend {
  abstract load(id: string): Observable<Letterhead>;

  abstract loadLight(id: string): Observable<LetterheadLight>;

  abstract loadDefaultLight(): Observable<LetterheadLight | undefined>;

  abstract loadDefault(): Observable<Letterhead | undefined>;

  abstract list(request: PageRequest): Observable<PaginatedResult<Letterhead>>;

  abstract listAll(): Observable<Letterhead[]>;

  abstract listAllLight(): Observable<LetterheadLight[]>;

  abstract create(payload: LetterheadCreate): Observable<Letterhead>;

  abstract delete(id: string): Observable<void>;

  abstract update(id: string, payload: LetterheadUpdate): Observable<void>;
}
